import { render, staticRenderFns } from "./UserProfileDropdownItem.vue?vue&type=template&id=8a441f48"
import script from "./UserProfileDropdownItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileDropdownItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports